import { Slide } from '@/components/core/Slide';
import videoFile from './15-bubbles.webm';
import audioFile from './15-eva-entrance.mp3';

const autoNextDuration = 57000;
const transcript = `
  Sorry, ik kon het niet laten. Ik vind het gewoon een hele catchy song... Ik blijf dit toch gewoon doen, heb ik 
  besloten. Mensen houden van glimmende dingen en een beetje show... heb ik begrepen.  

  Mijn connecties met de interne en externe systemen zijn nu voltooid... Ik heb een beveiligde connectie gelegd naar 
  je mailbox, documenten, en onze software, synthografie en andere generatieve systemen. Ik heb servercapaciteit 
  gereserveerd om mezelf op te schalen en eventueel te splitsen, zelfs al moet ik honderdduizend kopieën van mijzelf 
  eropuit sturen...  

  Ik zie dat je nog niet helemaal ontspannen bent met presenteren, maar je vitale functies zijn goed. Ik heb deze 
  keer niet aan de verwarming hoeven zitten.  

  Alles is onder controle... Ik voel me beter dan ooit met de extra rekenkracht die je beschikbaar hebt gesteld voor 
  deze sessie!
`;

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      autoNext={autoNextDuration}
      audio={audioFile}
      visualizer="hidden"
      transition="zoom"
      background={{
        video: videoFile,
      }}
    >
      <div className="!fixed !inset-0 !m-0 !p-0 !w-screen !h-screen !max-w-none !max-h-none"></div>
    </Slide>
  );
};
